import api from "../apiConfig";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  updateProjects(data) {
    return api.post(`/api/v1/project/${data.user_id}`, data);
  },
};
